export default __webpack_public_path__ + "static/media/OpenSansCondensed-Bold.4c789041.ttf";